import { useState, useMemo } from 'react';
import { Button } from 'antd';
import styled from 'styled-components';

import { useApolloContext, useQuery } from 'utils/apollo';
import { SelectableAction, useSelectableRecords } from 'utils/selectable';
import { TABLE_SCROLL_WIDTH_SMALL } from 'utils/constants';

import DataTable from 'components/DataTable';
import { name, location, status, make, model } from 'components/data/turbines';
import { LocationChooser } from 'components/choosers';

import GET_TURBINE_CHOOSER from './queries/GetTurbineListChooser.gql';

const Control = styled.div`
  .ant-select {
    min-width: 200px;
  }
`;

const columns = [name, location, status, make, model];

export default function BulkTurbineChooser({ onChange }) {
  const { papiClient } = useApolloContext();
  const [locationId, setLocationId] = useState(undefined);
  const { selected, rowSelection, onClearSelection } = useSelectableRecords();
  const { data, loading } = useQuery(GET_TURBINE_CHOOSER, {
    client: papiClient,
  });
  const turbines = data?.turbines ?? [];

  const filteredTurbines = useMemo(
    () => turbines.filter(turbine => (locationId ? turbine.location?.id === locationId : true)),
    [turbines, locationId]
  );

  function handleAdd() {
    onChange(selected);
  }

  function handleLocationChange(value) {
    // we standardized chooser selects to return an array instead of a singular item, so grab the singular item
    const locationId = value instanceof Array ? value[0] : value;
    setLocationId(locationId);
  }

  return (
    <DataTable
      loading={loading}
      scrollWidth={TABLE_SCROLL_WIDTH_SMALL}
      size="small"
      columns={columns}
      data={filteredTurbines}
      rowSelection={rowSelection}
      controls={
        <Control>
          <LocationChooser value={locationId} onChange={handleLocationChange} />
        </Control>
      }
      actions={
        <SelectableAction selected={selected} onClear={onClearSelection}>
          <Button type="primary" disabled={!selected.length} onClick={handleAdd}>
            Add
          </Button>
        </SelectableAction>
      }
    />
  );
}
